<div class="hero-shell">
  <div class="hero-grid">
    <div class="hero-copy text-slider">
      <div class="hero-copy-text">
        <div class="hero-copy-slide" [class.is-active]="actualSlider === 0">
          <h1 class="title-home-page">Allocation Calculator</h1>
          <h4 class="text-home-page">{{ "SlideMainTextAC" | translate }}</h4>
        </div>
        <div class="hero-copy-slide" [class.is-active]="actualSlider === 1">
          <h1 class="title-home-page">Goal Planner</h1>
          <p class="text-home-page">{{"SlideMainTextGP" | translate }}</p>
        </div>
      </div>

      <div class="slideshow-pager-bullets">
        <div class="item-list">
          <ul>
            @for (item of slides; track item.img; let i = $index) {
              <li [ngClass]="{'active': actualSlider === i }" class="w3-panel li-0"
                (click)="goToSlide(i)">{{ i }}</li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="hero-media container-slider-home">
      <div class="hero-frame">
        <div class="hero-frame-inner">
          @for (slide of slides; track slide.img; let i = $index) {
            <img
              class="hero-slide-img"
              [class.is-active]="actualSlider === i"
              [src]="slide.img"
              [alt]="i === 0 ? 'Allocation Calculator' : 'Goal Planner'"
              loading="lazy">
          }
        </div>
      </div>
    </div>
  </div>

  <app-home-stats></app-home-stats>

  <div class="app-to">
    <p style="width:100%;margin-top:20px; margin-bottom:12px;">
      <a href="/calculator/" style="margin:auto;display: block;width: fit-content;cursor:pointer;">
        <span class="btn-hero">{{"TextToApp" | translate }}</span>
      </a>
    </p>
    <p class="text-align-center">{{ "TextToAppDescription" | translate }}</p>
  </div>
</div>
